module.exports = __webpack_public_path__ + "img/trivia-error-opponent.394bf414.svg";